export default __webpack_public_path__ + "static/media/Inconsolata-SemiBold.48078943.ttf";